import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const DoubleChevronLeft = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={iconColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-chevrons-left"
    >
      <title>{iconTitle}</title>
      <polyline points="11 17 6 12 11 7" />
      <polyline points="18 17 13 12 18 7" />
    </svg>
  );
};

DoubleChevronLeft.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

DoubleChevronLeft.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(DoubleChevronLeft);
